import React from "react";
import $ from "$";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import trim from "lodash/trim";
import { callApi } from "../../wea-tools/callApi";
import * as getSelect from "./getSelect";
import * as getButtons from "./getButtons";

function escape2Html(str) {
  const arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, (all, t) => arrEntities[t]);
}

class Associative extends React.Component {
  static defaultProps = {
    data: [],
    showTitle: false
  };

  state = {
    loading: false,
    focus: false,
    dropdownWidth: 200,
    hrmlist: [],
    hrmlistVisible: false,
    hrmlistStyle: null,
    hrmVisible: false,
    searchList: [],
    activeKey: "",
    loadSelect: false,
    searchCache: ""
  };

  constructor(props) {
    super(props);
    const functions = [getSelect, getButtons];
    functions.map(funcs => {
      Object.keys(funcs).forEach(f => {
        if (typeof funcs[f] === "function") {
          this[f] = funcs[f].bind(this);
        }
      });
    });
  }

  componentDidMount() {
    // this.componentWillReceiveProps(this.props);
    const { dropdownWidth } = this.state;
    const w = $(this.searchWrapper).outerWidth() || 0;
    if (dropdownWidth < w) {
      this.setState({ dropdownWidth: w });
    }
    if (this.props.defaultFocus) {
      this.setState({ focus: true });
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   const { defaultFocus } = nextProps;
  //   if (defaultFocus && !this.state.focus) {
  //     this.setState({ focus: true });
  //   }
  // }

  // componentDidUpdate() {
  // const dom = this.searchWrapper;
  // if (dom) {
  //   if (this.state.focus) {
  //     $(dom)
  //       .find(".ant-select-search--inline")
  //       .css("minWidth", "10px");
  //     $(dom)
  //       .find("input")
  //       .focus();
  //   } else {
  //     $(dom)
  //       .find(".ant-select-search--inline")
  //       .css("minWidth", "0px");
  //   }
  // }
  // }

  isCrm = () => {
    const { type = 1 } = this.props;
    return type == "1" || type == "17";
  };

  clear() {
    this.setState({ data: [] });
  }

  getData = (name = "") => {
    const {
      isSingle,
      type = 1,
      oldUrl,
      completeURL,
      completeParams
    } = this.props;
    let url = completeURL || `/api/public/browser/complete/${type}?`;
    if (oldUrl) {
      url = `/api/ec/api/data/search?type=${type}&`;
    }
    if (trim(name)) {
      this.setState({ searchCache: name });
      callApi(url, "GET", { q: name, ...completeParams }).then(res => {
        if (this.state.searchCache !== name) return;
        let searchList =
          isString(res.datas) && res.datas.length > 0
            ? JSON.parse(res.datas)
            : res.datas;
        if (oldUrl) {
          searchList = res;
        }
        if (!searchList) {
          searchList = [];
        }
        let selectIds = [];
        this.props.data.forEach(item => {
          if (this.isCrm() && !isSingle && item.type !== "resource") {
            selectIds = selectIds.concat(
              Array.isArray(item.users)
                ? item.users.map(user => user.id || "")
                : []
            );
          } else {
            selectIds.push(item.id);
          }
        });
        if (this.isCrm() && !isSingle) {
          // 需要过滤已选中数据（部门，分组）
          const filterDatas = [];
          searchList.forEach(item => {
            item.type = "resource";
            item.nodeid = `resource_${item.id}x`;
            item.lastname = item.name;
            if (selectIds.indexOf(item.id) === -1) {
              filterDatas.push(item);
            }
          });
          searchList = filterDatas;
        }
        let activeKey = "";
        if (!isEmpty(searchList)) {
          const activeList = searchList.filter(
            d => selectIds.indexOf(d.id) == -1
          );
          if (!isEmpty(activeList)) activeKey = activeList[0].id;
        }
        this.setState({ searchList, loading: false, activeKey });
      });
    } else {
      this.setState({ searchList: [], loading: false, activeKey: "" });
    }
  };

  getTitle = () => {
    const { showTitle } = this.props;
    if (!showTitle) return "";
    const { data } = this.props;
    const temp = data.map(item => item.name);
    return escape2Html(temp.join(","));
  };

  render() {
    const {
      isSingle,
      style,
      linkUrl,
      viewAttr,
      fieldName,
      mr0,
      resize,
      hasAddBtn,
      customIcon,
      hasBorder,
      whiteBackground,
      underline,
      hideOps,
      linked,
      valueWarp,
      hasAddGroup,
      cls,
      data
    } = this.props;
    const cStyle = { ...style };
    cStyle.textDecoration = "none";
    const clsName = classNames(
      cls,
      "wea-associative-search",
      `wea-associative-${isSingle ? "single" : "search-mult"}`,
      {
        mr0,
        resize,
        underline,
        hideops: hideOps,
        required: viewAttr == "3" && isEmpty(data),
        mr15: /^field/.test(fieldName) || (viewAttr == "3" && isEmpty(data)),
        custom: hasAddBtn || customIcon,
        border: hasBorder,
        white: whiteBackground,
        "ext-btn":
          hasAddBtn ||
          customIcon ||
          (!isSingle && !(viewAttr == "1") && hasAddGroup),
        "wea-associative-click": this.isCrm() || !isEmpty(linkUrl) || linked,
        "value-warp": valueWarp,
        "wea-field-readonly": viewAttr == "1"
      }
    );
    return (
      <div
        id={`${fieldName}span`}
        title={this.getTitle()}
        className={clsName}
        style={cStyle}
        ref={el => {
          if (el) this.searchWrapper = el;
        }}
      >
        {this.getSelect(viewAttr == "1")}
        {this.getButtons()}
      </div>
    );
  }
}

export default Associative;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/associative/index.js